import _ from "lodash";

const formatDateFields = (order) => {
  Object.keys(order).forEach((key) => {
    if (key.includes("Date")) {
      order[key] = order[key]
        ? new Date(order[key]).toISOString().split("T")[0]
        : null;
    }
  });
};

const normalizeAttrsToString = (obj) =>
  _.mapValues(
    obj,
    (value) => (value == null ? null : String(value).trim()) // Convert everything to string for loose comparison
  );

const formatNotifications = (notifications) => {
  return notifications.map((notification) => {
    // const orderIdMatch = notification.message.match(/Order ID: (\d+)/);
    // const orderId = orderIdMatch ? parseInt(orderIdMatch[1], 10) : null;
    // const updatedMessage = notification.message
    //   .replace(/Order ID: \d+/, "")
    //   .trim();

    return {
      ...notification,
      subject: notification.subject.replace(/_/g, " "), // Replace underscores with spaces
    };
  });
};

const formatDate = (dateArray) => {
  // Destructure the array into individual date components
  const [year, month, day, hour, minute, second, millisecond] = dateArray;

  // Create a Date object (Note: month is 0-based, so subtract 1)
  const date = new Date(
    year,
    month - 1,
    day,
    hour,
    minute,
    second,
    millisecond / 1000
  );

  // Format the date using Intl.DateTimeFormat
  return new Intl.DateTimeFormat("en-US", {
    weekday: "long", // e.g., "Monday"
    year: "numeric", // e.g., "2025"
    month: "long", // e.g., "March"
    day: "numeric", // e.g., "24"
    hour: "2-digit", // e.g., "04"
    minute: "2-digit", // e.g., "28"
    second: "2-digit", // e.g., "58"
  }).format(date);
};

export { formatDateFields, normalizeAttrsToString, formatNotifications, formatDate };
